module.exports = "/assets/site/images/icon-email.png?acfa6975044980692ebda38b4f784612";